// AKA Base Solution
// Version 1.1
//
// Authors: Vinicius Artioli, Catia Melo, Tony Possamai, Chris Muldoon, Josh Winterbottom, Jeremy Basolo,Sam Johnson, Aung Myo Win

import "../scss/styles.scss";

import "jquery";
window.$ = jQuery;

import "bootstrap";
import "@popperjs/core";

// COMMON
import "./common/header";
import "./common/lazy-videos";
// import "./common/widont";

// BLOCKS
import "./blocks/block-production-cards";
// import "./blocks/block-cards-image";
import "./blocks/block-cards-news";
import "./blocks/block-carousel-and-text";
import "./blocks/block-cast-and-creative";
import "./blocks/block-gallery-global";
import "./blocks/block-gallery-scroller";
import "./blocks/block-hero-carousel-global";
import "./blocks/block-quote-slider";
import "./blocks/block-tabs";
import "./blocks/block-text-and-thumbnails";
import "./blocks/block-production-list";
import "./blocks/block-page-title";



$(function () {
	$("body").removeClass("loading");
});

document.addEventListener('DOMContentLoaded', function () {
	// Replace `.gfield_checkbox input` if your form uses a different class
	document.querySelectorAll('.gfield_checkbox input[type="checkbox"]').forEach(function (checkbox) {
		checkbox.addEventListener('change', function () {
			const parent = checkbox.closest('.gchoice');

			if (checkbox.checked) {
				parent.classList.add('checkbox-checked');
			} else {
				parent.classList.remove('checkbox-checked');
			}
		});
	});
});
